import Layout from "@/shared/components/Layout";
import LeftInfoCol from "@/modules/calculator/components/LeftInfoCol";
import ChecklistGraph from "@/shared/components/charts/ChecklistGraph";
import StageGraph from "@/shared/components/charts/StageGraph";
import ScorecardGraph from "@/shared/components/charts/ScorecardGraph";
import StepupGraph from "@/shared/components/charts/StepupGraph";
import RiskGraph from "@/shared/components/charts/RiskGraph";
import FourmethodsValuationGraph from "@/shared/components/charts/FourmethodsValuationGraph";
import CountryRangeGraph from "@/shared/components/charts/CountryRangeGraph";
import WorldRangeGraph from "@/shared/components/charts/WorldRangeGraph";
import IndustryRangeGraph from "@/shared/components/charts/IndustryRangeGraph";
import ShareholdersGraph from "@/shared/components/charts/ShareholdersGraph";
import InvestmentPercentageGraph from "@/shared/components/charts/InvestmentPercentageGraph";
import FundUseGraph from "@/shared/components/charts/FundUseGraph";
import {ReportAPI} from "@/apis/ReportAPI";
import CapitalNeededGraph from "@/shared/components/charts/CapitalNeededGraph";
import ProgressGraph from "@/shared/components/charts/ProgressGraph";
import {FOUNDERS_MAP} from "@/modules/calculator/forms/constants";

export default {
  name: 'PDFReport',
  components: {
    Layout,
    LeftInfoCol,
    ChecklistGraph,
    StageGraph,
    ScorecardGraph,
    RiskGraph,
    StepupGraph,
    FourmethodsValuationGraph,
    CountryRangeGraph,
    WorldRangeGraph,
    IndustryRangeGraph,
    ShareholdersGraph,
    InvestmentPercentageGraph,
    FundUseGraph,
    CapitalNeededGraph,
    ProgressGraph,
  },
  data() {
    return {
      reportData: {}
    }
  },
  props: ['data'],
  async mounted() {
    this.reportData = await ReportAPI.getReport(this.$route.params.id)
  },
  methods: {},
  computed: {
    target_customer_locations(){
      return this.reportData.report.target_customer_locations.map(item=>item.name)
    },
    Q22(){
      if(this.reportData.answers.Q22.indexOf('More than')>-1){
        return '+3';
      }
      return FOUNDERS_MAP[this.reportData.answers.Q22];
    },
    Q27(){
      return this.reportData.answers.Q27.replace('years.', '').replace(' to ', ' - ')
    }
  },
}

window.onafterprint = function () {
  window.close();
}

window.onload = function () {
  setTimeout(() => {
    // window.print();
  }, 1500)
}
